/* eslint-disable */
import { Flex, Text, useMatchBreakpoints, ChevronDownIcon, useModal, Skeleton } from '@noahswap/uikit' // eslint-line
import formatTimestamp from 'utils/formatTimestamp'
import { useWeb3React } from '@noahswap/wagmi'
import styled from 'styled-components'
// @ts-ignore
// eslint-disable-next-line import/extensions
import { useActiveHandle } from 'hooks/useEagerConnect.bmp.ts'
import { useWallet } from 'hooks/useWallet'
import { useEffect, useState, useRef } from 'react'
import { calculateGasMargin } from 'utils'
import { getVotePools, getEpoch } from 'service/service'
import chainUtils from 'service/chainUtils'
import { useRouter } from 'next/router'
import { useGasPrice } from 'state/user/hooks'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
// import { Updater } from 'state/transactions/updater'
import { DoubleCurrencyLogo } from 'views/Info/components/CurrencyLogo'
import ResultModal from 'components/ResultModal'
import {
  formatBigNumberToFixed,
  formatFixedNumber,
  truncate,
  truncateZero,
  getRes,
  formatEffectiveNumber,
} from 'utils/formatBalance'
import { parseUnits } from '@ethersproject/units'
import Link from 'next/link'
import { useVotingEscrowContract, useVoterContract, useMinterContract } from 'hooks/useContract'
import QuestionHelper from 'components/QuestionHelper'
import { useTranslation } from '@noahswap/localization'
import { ListLogo } from 'components/Logo'
import { useTransactionAdder } from 'state/transactions/hooks'
import { transactionErrorToUserReadableMessage } from 'utils/transactionErrorToUserReadableMessage'
import AllLPModal from './components/AllLPModal'
import VoteModal from './components/VoteModal'
import styles from './style/index.module.scss'
import ResetModal from './components/ResetModal'
// import { ALLOWED_PATHS } from 'config/index'
// import { DEFAULT_CHAINID } from 'config'
const deepEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i].id !== arr2[i].id) return false
  }
  return true
}

export default function Vote() {
  const router = useRouter()
  const { provider, chainId } = useActiveWeb3React()

  // useEffect(() => {
  // console.log('router', router.pathname, chainId)
  // if(chainId == DEFAULT_CHAINID && !ALLOWED_PATHS.includes(router.pathname)){
  //   console.log('不存在的路由')
  //   router.replace(`/404`)
  //   // router.push(`/404`)
  //   return null
  // }
  // }, [router.pathname, chainId]);

  const handleActive = useActiveHandle()
  const { onPresentConnectModal } = useWallet()
  // const { provider, chainId } = useActiveWeb3React()
  // 农场
  const { t } = useTranslation()
  const gasPrice = useGasPrice()
  // console.log(testa, 'testa')
  const addTransaction = useTransactionAdder()
  // const router = useRouter()

  const { account } = useWeb3React()
  // console.log(chainId, 'chainId')
  const { isMobile } = useMatchBreakpoints()

  const [nowep, setNowEP] = useState(null)
  const [startTime, setStartTime] = useState(null)
  const [endTime, setEndTime] = useState(null)

  const [searchValue, setSearchValue] = useState('')
  const [showPanel, setShowPanel] = useState(false)
  const [staked, setStaked] = useState('0.00')
  const [amount, setAmount] = useState('0.00')
  const [myVotes, setMyVotes] = useState('0.0000')

  const [epoch, setEpoch] = useState('0')

  const [epochAt, setEpochAt] = useState('0')
  const [lasteds, setLasteds] = useState('0')

  // const [finalVotes, setFinalVotes] = useState({})
  const [symobj, setSymobj] = useState(null) // 需要传递的item, 当前
  const [noVotes, setNoVote] = useState(true) // 禁止投票
  const [week, setWeek] = useState(false) // 本周已投过票
  const [reset, setReset] = useState<any>(0) // 0 --- 有池子已投票不允许reset 1---有池子未投票允许reset 2 --- 没池子未投票不允许reset
  const [list, setList] = useState([])
  const VotingEscrowContract = useVotingEscrowContract()
  const VoterContract = useVoterContract()
  const MinterContract = useMinterContract()
  // const parsedQueryChainId = Number(router.query.cha //inId)
  // const chainId = parsedQueryChainId || Number(localStorage.getItem('chainId'))
  const [loading, setLoading] = useState(false)
  const [state, setState] = useState({
    votes: {},
    totalVotes: 0,
    votedItems: [],
  })
  const ResponsiveGrid = styled.div<{ tableHead?: boolean }>`
    display: grid;
    grid-gap: 1em;
    align-items: center;
    // grid-template-columns: repeat(6, 2fr);
    grid-template-columns: 18% 16% 18% 18% 10% auto;
    background: ${({ tableHead }) => (tableHead ? '#F2F2F2' : '#fff')};
    margin-top: ${({ tableHead }) => (tableHead ? '10px' : '10px')};
    border-radius: ${({ tableHead }) => (tableHead ? '8px' : '0px')};
    text-align: center;
    grid-template-columns::nth-child(1) {
      border: 1px solid red;
    }
    // padding: 0 24px;
    @media screen and (max-width: 1200px) {
      padding: 0 20px;
      // grid-template-columns: 200px 1.5fr repeat(3, 2fr);
      grid-template-columns: 35% 30% 31%;
      & :nth-child(4),
      & :nth-child(5),
      & :nth-child(6) {
        display: none;
      }
    }
    @media screen and (max-width: 500px) {
      padding: 0 20px;
      grid-template-columns: 35% 30% 25% !important;
      & :nth-child(4),
      & :nth-child(5),
      & :nth-child(6) {
        display: none;
      }
    }
    // @media screen and (max-width: 480px) {
    //   grid-template-columns: 2.5fr repeat(1, 1fr);
    //   > *:nth-child(1) {
    //     display: none;
    //   }
    // }
  `
  const LoadingRow: React.FC<React.PropsWithChildren> = () => (
    <ResponsiveGrid>
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
    </ResponsiveGrid>
  )

  const TableLoader: React.FC<React.PropsWithChildren> = () => (
    <>
      <LoadingRow />
      <LoadingRow />
      <LoadingRow />
      <LoadingRow />
      <LoadingRow />
    </>
  )

  // console.log(VoterContract, 'VoterContract')
  // console.log(VotingEscrowContract, 'VotingEscrowContract')
  // console.log(MinterContract, 'MinterContract')

  const openModalWithItem = (item) => {
    setSymobj(item)
    onPresentAllLPModal()
  }

  const getDataStart = async () => {
    try {
      // if(!account && totalVotes != 100){
      //   setNoVote(true)
      // } else {
      //   setNoVote(false)
      // }
      // console.log('VotingEscrowContract', VotingEscrowContract)
      // console.log('VoterContract', VoterContract)

      const supply = await VotingEscrowContract.supply() // 质押量
      const bb = await VoterContract.totalWeight() // 投票数量
      // const cepoch = await MinterContract.epoch() // 查询当前所在期数(纪元)
      setStaked(formatBigNumberToFixed(supply || 0, 2))
      setAmount(formatBigNumberToFixed(bb || 0, 2))
      // setEpoch(cepoch.toString())

      // console.log('质押量', formatBigNumberToFixed(supply || 0, 2))
      // console.log('投票数量', formatBigNumberToFixed(bb || 0, 2))
      // console.log('查询当前所在期数(纪元)', cepoch.toString())
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (!VotingEscrowContract && !VoterContract) return
    getDataStart()
    getData(account)
  }, [account, VotingEscrowContract, VoterContract])

  useEffect(() => {
    const { baseURL, chainid } = chainUtils()
    const env = process.env.NODE_ENV
    // console.log(env, baseURL, chainid)
    setLoading(true)
    const fetch = async () => {
      try {
        const { code, data } = await getVotePools({ baseURL, chainid })
        // console.log(code, 'code')
        if (!code) {
          // console.log(data)
          const dataFormat = data?.map((current) => {
            return {
              token0: {
                address: current.contract0,
                symbol: current.symbol0,
              },
              token1: {
                address: current.contract1,
                symbol: current.symbol1,
              },
              ...current,
            }
          })
          // console.log(dataFormat, 'dataFormat')
          // let test = [...dataFormat, ...dataFormat, ...dataFormat]
          setList(dataFormat)
          // setLoading(false)
        } else {
          setLoading(false)
          setList([])
          // setDefaultFetchState([])
        }
      } catch (error) {
        console.log(error)
        setList([])
      }
    }
    // if (!chainId) return
    fetch()
  }, [])

  const getData = async (account: any) => {
    let combined = []
    try {
      // setLoading(true)
      const myvotes = await VotingEscrowContract.balanceOf(account) // 我的票数
      const usedWeights = await VoterContract.usedWeights(account) // 总权重
      const lasted = await VoterContract.lastVoted(account) // 最后一次投票时间戳
      const epochAt = await MinterContract.epochAt(lasted.toString()) // 查询传的时间戳所在期数
      const userVotes = await VoterContract['userVotes(address)'](account) // 批量查询用户投票数据
      setMyVotes(formatBigNumberToFixed(myvotes || 0))

      // console.log('合约返回的总权重', formatBigNumberToFixed(usedWeights || 0))
      // console.log('userVotes', userVotes)

      // 0 --- 有池子已投票不允许reset 1---有池子未投票允许reset 2 --- 没池子不允许reset
      if (userVotes._pools.length > 0) {
        if (week) {
          setReset(0) // 本记元已投票，无取消投票
        } else {
          setReset(1) // 可投票，可取消投票
        }
      } else {
        if (week) {
          setReset(2) // 本记元已取消投票，无取消投票
        } else {
          setReset(3) // 可投票，无取消投票
        }
      }
      if (userVotes._pools.length > 0 && userVotes._votes.length > 0) {
        combined = userVotes._pools.map((pool, index) => {
          // 这里需要每个池子除以我的票数得出占比=======================================================================
          // console.log('合约返回的我的票数-' + index, formatBigNumberToFixed(userVotes._votes[index]))
          let voteVal = Math.round(
            (Number(formatBigNumberToFixed(userVotes._votes[index] || 0)) /
              Number(formatBigNumberToFixed(usedWeights || 0))) *
              100,
          )
          if (userVotes._votes[index].toString() == 0 && usedWeights == 0) {
            voteVal = 0
          }
          return {
            pool: pool,
            vote: voteVal,
            // vote:
            //   // truncate(
            //   //   Number(formatBigNumberToFixed(userVotes._votes[index])) /
            //   //     Number(formatBigNumberToFixed(usedWeights || 0)),
            //   //   2,
            //   // ) * 100,
            //   Math.round(
            //     (Number(formatBigNumberToFixed(userVotes._votes[index] || 0)) /
            //       Number(formatBigNumberToFixed(usedWeights || 0))) *
            //       100,
            //   ),
          }
        })
      }

      // console.log(combined, 'combined')
      const idMap = {}
      list.forEach((item) => {
        idMap[item.pair_id] = item.id
      })

      // console.l
      // console.log(combined, 'combined================================')
      combined.forEach((item) => {
        const id = idMap[item.pool]
        if (id !== undefined) {
          votes[id] = item.vote
        } else {
          votes[id] = 0
        }
      })

      // console.log(votes, 'votes', list)

      const two = (Object.values(votes) as number[]).reduce((a, b) => a + b, 0)
      // console.log('two', two)
      const three = list.filter((item) => votes[item.id] !== 0).map((item) => ({ ...item, votes: votes[item.id] }))

      setState({
        // 拿到的批量数据更新
        votes: votes,
        // votes: {1: 20, 2: 40},
        totalVotes: two,
        votedItems: three,
      })

      // console.log('我的票数', formatBigNumberToFixed(myvotes || 0))
      // console.log('总权重', usedWeights.toString())
      // console.log('最后一次投票时间戳', lasted.toString())
      // console.log('上一次投票所在期数', epochAt.toString())
      // console.log('当前所在期数', epoch)

      // console.log('批量查询', userVotes)
      // console.log('投票数据', combined)
      setLasteds(lasted.toString())
      setEpochAt(epochAt.toString())

      setLoading(false)
      // console.log(epoch, epochAt.toString(), '00000', totalVotes)
      // 如果用户没有投过票，即用户最后投票时间戳为0，即可投票
      // 查询当前所在期数(纪元) 与 传的时间戳所在期数 比对，不相等可以投票
      // 2023/6/25 注释================
      // if ((lasted.toString() == 0 || epoch != epochAt.toString()) && totalVotes === 100) {
      //   setNoVote(false) // 为false, 可以投票
      // } else {
      //   setNoVote(true) // 为true, 禁止投票
      // }
      // 2023/6/25 注释================
      // 本周已投过票
      // if (lasted.toString() != 0) {
      //   setWeek(true)
      // }
      // 本周期未投过票
      // if (lasteds.toString() == '0' || epoch != epochAt.toString()) {
      //   setWeek(false)
      //   setNoVote(false) // 为false, 可以投票
      // } else {
      //   console.log('@@@@@@@@@@@@已经投过票')
      //   setWeek(true)
      //   setNoVote(true) // 为true, 禁止投票
      //   console.log('@@@@@@@@@@@@已经投过票@@@@@@@@@@@')
      // }
    } catch (error) {
      console.log()
    }
  }

  useEffect(() => {
    // console.log('最后一次投票时间戳', lasteds.toString())
    // console.log('上一次投票所在期数', epochAt.toString())
    // console.log('当前所在期数', epoch)
    if (lasteds.toString() == '0' || epoch != epochAt.toString()) {
      setWeek(false)
      setNoVote(false) // 为false, 可以投票
    } else {
      // console.log('@@@@@@@@@@@@已经投过票')
      setWeek(true)
      setNoVote(true) // 为true, 禁止投票
      // console.log('@@@@@@@@@@@@已经投过票@@@@@@@@@@@')
    }
  }, [lasteds, epoch, epochAt, account])

  // useEffect(() => {
  //   console.log('reset', reset)
  // },[reset])

  useEffect(() => {
    if (!account) {
      setMyVotes('0.0000')
      setLoading(false)
      // getDataStart()
    }
    // console.log('执行1111')
    if (!account && !VotingEscrowContract && !VoterContract && !MinterContract) return
    // console.log('执行2222')
    getData(account)
  }, [account, list, VotingEscrowContract, VoterContract, MinterContract, week])

  useEffect(() => {
    const { baseURL, chainid } = chainUtils()
    const epochs = async () => {
      try {
        const { code, data } = await getEpoch({ baseURL, chainid })
        if (!code) {
          // console.log(data)
          setEpoch(data.epoch)
          setStartTime(data.startTime)
          setEndTime(data.endTime)
        } else {
        }
      } catch (err) {
        console.log(err)
      }
    }
    epochs()
  }, [])

  // const list = [
  //   {
  //     symbol0: 'BNB',
  //     symbol1: 'EOS',
  //     img0: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0xaf3738cdae9aa9e3dac27d5a5d9ee8f08cdea036-btc.png',
  //     img1: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0x8fcd76769be5c4af087bf52fd4a27af9636425c4-bnb.png',
  //     contract0: '0x461d52769884ca6235b685ef2040f47d30c94eb5',
  //     contract1: '0xc00592aa41d32d137dc480d9f6d0df19b860104f',
  //     name0: 'Binance',
  //     name1: 'Wrapped EOS',
  //     towVal: '39783767.89',
  //     twoRate: '10.89%',
  //     threeVal: '83767.89',
  //     threeUs: '$ 783,767.89',
  //     baseRate: '3767.89',
  //     heightRate: '63767.89',
  //     allLP: '87.87%',
  //     id: 1,
  //   },
  //   {
  //     symbol0: 'BNB',
  //     symbol1: 'EOS',
  //     img0: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0xaf3738cdae9aa9e3dac27d5a5d9ee8f08cdea036-btc.png',
  //     img1: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0x8fcd76769be5c4af087bf52fd4a27af9636425c4-bnb.png',
  //     contract0: '0x461d52769884ca6235b685ef2040f47d30c94eb5',
  //     contract1: '0xc00592aa41d32d137dc480d9f6d0df19b860104f',
  //     name0: 'Binance',
  //     name1: 'Wrapped EOS',
  //     towVal: '0',
  //     twoRate: '10.89%',
  //     threeVal: '0',
  //     threeUs: '$ 783,767.89',
  //     baseRate: '0',
  //     heightRate: '63,767.89 BCD',
  //     allLP: '0.00%',
  //     id: 2,
  //   },
  //   {
  //     symbol0: 'BNB',
  //     symbol1: 'EOS',
  //     img0: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0xaf3738cdae9aa9e3dac27d5a5d9ee8f08cdea036-btc.png',
  //     img1: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0x8fcd76769be5c4af087bf52fd4a27af9636425c4-bnb.png',
  //     contract0: '0x461d52769884ca6235b685ef2040f47d30c94eb5',
  //     contract1: '0xc00592aa41d32d137dc480d9f6d0df19b860104f',
  //     name0: 'Binance',
  //     name1: 'Wrapped EOS',
  //     towVal: '0.0003',
  //     twoRate: '10.89%',
  //     threeVal: '0.0001',
  //     threeUs: '$ 783,767.89',
  //     baseRate: '3767.89',
  //     heightRate: '63767.89',
  //     allLP: '87.87%',
  //     id: 3,
  //   },
  //   {
  //     symbol0: 'BNB',
  //     symbol1: 'EOS',
  //     img0: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0xaf3738cdae9aa9e3dac27d5a5d9ee8f08cdea036-btc.png',
  //     img1: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0x8fcd76769be5c4af087bf52fd4a27af9636425c4-bnb.png',
  //     contract0: '0x461d52769884ca6235b685ef2040f47d30c94eb5',
  //     contract1: '0xc00592aa41d32d137dc480d9f6d0df19b860104f',
  //     name0: 'Binance',
  //     name1: 'Wrapped EOS',
  //     towVal: '39783767.89',
  //     twoRate: '10.89%',
  //     threeVal: '83767.89',
  //     threeUs: '$ 783,767.89',
  //     baseRate: '3767.89',
  //     heightRate: '63767.89',
  //     allLP: '87.87%',
  //     id: 4,
  //   },
  //   {
  //     symbol0: 'BNB',
  //     symbol1: 'EOS',
  //     img0: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0xaf3738cdae9aa9e3dac27d5a5d9ee8f08cdea036-btc.png',
  //     img1: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0x8fcd76769be5c4af087bf52fd4a27af9636425c4-bnb.png',
  //     contract0: '0x461d52769884ca6235b685ef2040f47d30c94eb5',
  //     contract1: '0xc00592aa41d32d137dc480d9f6d0df19b860104f',
  //     name0: 'Binance',
  //     name1: 'Wrapped EOS',
  //     towVal: '39783767.89',
  //     twoRate: '10.89%',
  //     threeVal: '83767.89',
  //     threeUs: '$ 783,767.89',
  //     baseRate: '3767.89',
  //     heightRate: '63767.89',
  //     allLP: '87.87%',
  //     id: 5,
  //   },
  //   {
  //     symbol0: 'BNB',
  //     symbol1: 'EOS',
  //     img0: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0xaf3738cdae9aa9e3dac27d5a5d9ee8f08cdea036-btc.png',
  //     img1: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0x8fcd76769be5c4af087bf52fd4a27af9636425c4-bnb.png',
  //     contract0: '0x461d52769884ca6235b685ef2040f47d30c94eb5',
  //     contract1: '0xc00592aa41d32d137dc480d9f6d0df19b860104f',
  //     name0: 'Binance',
  //     name1: 'Wrapped EOS',
  //     towVal: '39783767.89',
  //     twoRate: '10.89%',
  //     threeVal: '83767.89',
  //     threeUs: '$ 783,767.89',
  //     baseRate: '3767.89',
  //     heightRate: '63767.89',
  //     allLP: '87.87%',
  //     id: 6,
  //   },
  // ]
  // const [votes, setVotes] = useState({}); // 存储每一项的投票数
  const previousDataRef = useRef(list)
  // const [votedItems, setVotedItems] = useState([]); // 存储已投票的项目
  // const [totalVotes, setTotalVotes] = useState(0); // 存储总票数

  const ArrowIcon = styled(ChevronDownIcon)<{ toggled: boolean }>`
    position: absolute;
    right: 5px;
    top: 12px;
    transform: ${({ toggled }) => (toggled ? 'rotate(0deg)' : 'rotate(180deg)')};
    height: 25px;
    width: 25px;
  `

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
  })
  // 弹窗 传值
  const [onPresentAllLPModal] = useModal(<AllLPModal item={symobj} />, true, true, 'allLpModal')

  const [onPresentResetModal] = useModal(<ResetModal reset={reset} />, true, true, 'resetModal')
  // const [onPresentVoteModal] = useModal(
  // () => <VoteModal handleGoVote={handleGoVote} voteList={state} />,
  //   true,
  //   true,
  //   'voteModal'
  // );

  const rootRef = useRef(null)
  const [contentHeight, setContentHeight] = useState(0)

  // modal and loading
  const [{ attemptingTxn, pledgeErrorMessage, txHash }, setVoteState] = useState<{
    attemptingTxn: boolean
    pledgeErrorMessage: string | undefined
    txHash: string | undefined
  }>({
    attemptingTxn: false,
    pledgeErrorMessage: undefined,
    txHash: undefined,
  })

  const pendingText = t('Vote in %epoch%', { epoch: 'Epoch' + epoch })
  // 投票成功/投票失败
  const [{ successText, failText }, setText] = useState({
    successText: t('noah378'),
    failText: t('noah379'),
  })
  const [onPVoteResultModal] = useModal(
    <ResultModal
      pendingText={pendingText}
      hash={txHash}
      attemptingTxn={attemptingTxn}
      errorMessage={pledgeErrorMessage}
      successText={successText}
      failText={failText}
      isSuccess={() => {
        // console.log('执行合约成功了')
        getDataStart()
        getData(account)
      }}
    />,
    false,
    true,
    'ResultModal',
  )
  useEffect(() => {
    setContentHeight(rootRef.current.offsetHeight)
  }, [])

  useEffect(() => {
    document.body.classList.add('fixed-body')
    return () => {
      document.body.classList.remove('fixed-body')
    }
  }, [])
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = () => {
        // clearTimeout(timeoutId);
        // timeoutId = setTimeout(() => {
        setWindowSize({
          width: window.innerWidth,
        })
        // }, 150);
      }
      // 在组件挂载后，添加 resize 事件监听器
      window.addEventListener('resize', handleResize)
      // 在组件卸载时，删除事件监听器
      return () => window.removeEventListener('resize', handleResize)
    }
  }, [])

  // 先留着吧
  // useEffect(() => {
  //   if (!deepEqual(list, previousDataRef.current)) {
  //     const initialVotes = {}
  //     list.forEach((item) => {
  //       initialVotes[item.id] = 0
  //     })

  //     setState({
  //       votes: initialVotes,
  //       totalVotes: 0,
  //       votedItems: [],
  //     })

  //     previousDataRef.current = list
  //   }
  // }, [list])

  // 计算票数
  const handleVote = (item, increment) => {
    setState((prevState) => {
      // console.log('prevState', prevState)
      const newVotes = { ...prevState.votes }
      newVotes[item.id] = newVotes[item.id] || 0 // 如果 votes[id] 未定义，设置为 0

      // console.log('newVotes[item.id]', newVotes[item.id], increment)

      const oldVote = newVotes[item.id]
      newVotes[item.id] += increment ? 5 : -5
      if (newVotes[item.id] < 0) {
        newVotes[item.id] = 0
      }

      // console.log('prevState.totalVotes', prevState.totalVotes)
      // 更新投票的总数
      const newTotalVotes = prevState.totalVotes + (newVotes[item.id] - oldVote)
      // console.log('aaaa', newTotalVotes)
      if (newTotalVotes == 100) {
        setNoVote(false) // 为false, 可以投票
      } else {
        setNoVote(true) // 为true, 禁止投票
      }
      // 2023/6/25 注释================
      // if ((lasteds == '0' || epoch != epochAt) && newTotalVotes == 100) {
      //   setNoVote(false) // 为false, 可以投票
      // } else {
      //   setNoVote(true) // 为true, 禁止投票
      // }
      // 如果新的总投票数大于100，不更新状态
      if (newTotalVotes > 100) {
        return prevState
      }

      let newVotedItems = [...prevState.votedItems]

      // 如果这个项目已经投票过，但新的投票数为 0，则从 votedItems 中移除它
      if (prevState.votedItems.find((votedItem) => votedItem.id === item.id) && newVotes[item.id] === 0) {
        newVotedItems = prevState.votedItems.filter((votedItem) => votedItem.id !== item.id)
      } else {
        // 如果这个项目已经投票过或新的投票数大于 0
        if (newVotes[item.id] > 0 || prevState.votedItems.find((votedItem) => votedItem.id === item.id)) {
          // 更新该项目的投票数
          const updatedItem = { ...item, votes: newVotes[item.id] }
          newVotedItems = newVotedItems.map((votedItem) => (votedItem.id === item.id ? updatedItem : votedItem))

          // 如果这个项目还没有投票过，添加到 votedItems 中
          if (!prevState.votedItems.find((votedItem) => votedItem.id === item.id)) {
            newVotedItems.push(updatedItem)
          }
        }
      }

      return {
        votes: newVotes,
        totalVotes: newTotalVotes,
        votedItems: newVotedItems,
      }
    })
  }

  const handleSearchValue = (e) => {
    setSearchValue(e.target.value)
    // console.log(searchValue)
  }
  const { votes, totalVotes, votedItems } = state
  // console.log(votes, totalVotes, votedItems)

  // 执行投票合约
  const handleGoVote = async () => {
    if (noVotes) return
    // console.log('参数', votedItems)
    let newVoted = [...votedItems]
    newVoted = await newVoted.filter((item) => item.votes !== undefined && item.votes !== 0)
    const pairIds = newVoted.map((item) => item.pair_id)
    const votes = newVoted.map((item) => item.votes * 10000)
    // console.log('执行投票方法', pairIds, votes)
    setVoteState({ attemptingTxn: true, pledgeErrorMessage: undefined, txHash: undefined })
    // console.log(attemptingTxn, 'setVoteState')
    onPVoteResultModal()
    let args = [pairIds, votes]
    // // console.log('参数', args)
    const estimate = VoterContract.estimateGas.vote
    let method = VoterContract.vote
    await estimate(...args)
      .then((estimatedGasLimit) =>
        method(...args, {
          gasLimit: calculateGasMargin(estimatedGasLimit),
          // gasLimit: 2100000,
          gasPrice,
        }).then((response) => {
          console.log('response', response)
          // 拿到交易hash
          const txHash = response.hash

          // 设置定时器，每隔一定时间（这里设为5秒）检查一次交易状态
          // const intervalId = setInterval(() => {
          //   console.log('执行检查交易状态')
          //   provider
          //     .getTransactionReceipt(txHash)
          //     .then(receipt => {
          //       console.log(receipt, 'receipt')
          //       if (receipt && receipt.status) {
          //         // 如果交易成功，你可以在这里处理你的逻辑
          //         console.log("交易成功！");

          //         // 清除定时器
          //         clearInterval(intervalId);
          //       }
          //     })
          //     .catch(error => {
          //       console.error(`Failed to get transaction receipt: ${txHash}`, error);
          //     });
          // }, 500);

          setVoteState({ attemptingTxn: false, pledgeErrorMessage: undefined, txHash: response.hash })
          addTransaction(response, {
            summary: 'Vote',
            translatableSummary: {
              text: 'noah366',
              data: { symbol: `Epoch ${epoch}` },
            },
            type: 'Vote',
          })
        }),
      )
      .catch((err) => {
        if (err && err.code !== 4001) {
          console.log(err)
          setVoteState({ attemptingTxn: false, pledgeErrorMessage: err.message, txHash: undefined })
        }
        setVoteState({
          attemptingTxn: false,
          pledgeErrorMessage:
            err && err.code !== 4001
              ? t('Vote failed: %message%', { message: transactionErrorToUserReadableMessage(err, t) })
              : undefined,
          txHash: undefined,
        })
      })
  }

  const [onPresentVoteModal] = useModal(
    <VoteModal handleGoVote={handleGoVote} voteList={state} />,
    true,
    true,
    'voteModal',
  )
  const handleClick = () => {
    if (typeof __NEZHA_BRIDGE__ !== 'undefined') {
      handleActive()
    } else {
      onPresentConnectModal()
    }
  }
  const handleReset = async () => {
    // console.log('week', week)
    // console.log('reset', reset)
    const estimate = VoterContract.estimateGas.reset
    const method = VoterContract.reset
    const args = []
    await estimate(...args)
      .then((estimatedGasLimit) =>
        method(...args, {
          gasLimit: calculateGasMargin(estimatedGasLimit),
          // gasLimit: 4000000,
          gasPrice,
        }).then((response) => {
          getDataStart()
          getData(account)
          // console.log(response, 'responseresponse')
          setVoteState({ attemptingTxn: false, pledgeErrorMessage: undefined, txHash: response.hash })
          // addTransaction(response, {
          //   summary: 'receive NOAH',
          //   translatableSummary: {
          //     text: `${t('noah260')} NOAH`,
          //     data: {},
          //   },
          //   type: 'receive',
          // })
        }),
      )
      .catch((err) => {
        // console.log(err, 'errrrrr')
        if (err && err.code !== 4001) {
          console.error(`Receive failed`, err)
          setVoteState({
            attemptingTxn: false,
            pledgeErrorMessage: err.message,
            txHash: undefined,
          })
        }
        setVoteState({
          attemptingTxn: false,
          pledgeErrorMessage:
            err && err.code !== 4001
              ? t('Receive failed: %message%', { message: transactionErrorToUserReadableMessage(err, t) })
              : undefined,
          txHash: undefined,
        })
      })
  }

  useEffect(() => {
    setWeek(false)
    setState({
      votes: {},
      totalVotes: 0,
      votedItems: [],
    })
  }, [account])
  return (
    <div className={windowSize.width > 1200 ? styles.bigBox : styles.bigBox_small}>
      <div
        className={`${windowSize.width < 1200 ? styles.sm_farms : styles.lg_farms} ${styles.box} ${styles.container}`}
        ref={rootRef}
      >
        <Text fontSize={windowSize.width > 1200 ? '24px' : '20px'} fontWeight="600" mb="10px">
          {t('noah339')}
        </Text>
        <div className={styles.tips}>{t('noah352')}</div>
        <div className={styles.topBox}>
          <div className={`${styles.period} flex flexb`}>
            <div className={`flex flexc`}>
              <img src="/images/all/vote.png" alt="" className={styles.voteImg} />
              <div className={styles.name}>Epoch {epoch}</div>
              {/* <div className={styles.time}>2023/5/10 23:59 -2013/5/17 23:59 （SGT）</div> */}
            </div>
            {/* 当前周期大于1展示 */}
            {epoch && Number(epoch) > 1 && (
              <div className={`${styles.btn} flexc`}>
                {/* 历史投票 */}
                <Link href="/vote/history">{t('noah367')}</Link>&nbsp;&gt;
              </div>
            )}
          </div>
          {/* style={{justifyContent: "space-around"}} */}
          <div className={`${styles.infos} flex flexb`}>
            <div
              className={`${styles.info} flex flexcol`}
              onClick={() => {
                setShowPanel(!showPanel)
                // console.log(showPanel)
              }}
            >
              {/* 投票时间 */}
              <div className={styles.label}>{t('noah354')}</div>
              <div className={styles.val}>
                {/* {startTime?.replace(/-/g, '/')}-{endTime?.replace(/-/g, '/')} */}
                {formatTimestamp(startTime / 1000, windowSize.width > 1200 ? 2 : 3)}-
                {formatTimestamp(endTime / 1000, windowSize.width > 1200 ? 2 : 3)}
                {windowSize.width < 1200 && (
                  <div className={`pointer`}>
                    <ArrowIcon color="#14162A" toggled={!showPanel} />
                  </div>
                )}
              </div>
            </div>
            {(showPanel || windowSize.width > 1200) && (
              <div className={`${styles.info} flex flexcol`}>
                {/* NOAH质押量 */}
                <div className={styles.label}>{t('noah355')}</div>
                <div className={styles.val}>{staked} NOAH</div>
              </div>
            )}
            {(showPanel || windowSize.width > 1200) && (
              <div className={`${styles.info} flex flexcol`}>
                {/* 投票数量 */}
                <div className={styles.label}>{t('noah356')}</div>
                <div className={styles.val}>
                  {amount} {t('noah357')}
                </div>
              </div>
            )}
            {/* {(showPanel || windowSize.width > 1200) && (
              <div className={`${styles.info} flex flexcol`}>
                农场挖矿 
                <div className={styles.label}>{t('noah358')}</div>
                <div className={styles.val}>788,789.78 esNOAH</div>
              </div>
            )} */}
          </div>
        </div>

        <div className={`${styles.tools} flex flexb`}>
          <div className={`${styles.myVotes} flex flexc`}>
            <div className={`flex flexc`}>
              {/* 我的票数 */}
              <div className={`${styles.label}`}>{t('noah359')}:</div>
              <div className={`${styles.val}`}>{getRes(myVotes, 4)}</div>
            </div>
            {/* 质押获得更多票数 */}
            <div className={`${styles.btn} flexc pointer`}>
              <Link href="/pledge">{t('noah360')}</Link>&nbsp;&gt;
            </div>
          </div>
          {/* 搜索 */}
          {/* {windowSize.width > 1200 && (
            <div className={`${styles.searchBox} flex flexc`}>
              <img src="/images/small-img/icon3.png" alt="" className={styles.img} />
              <div className="flex flexc">
                <input
                  className={styles.input}
                  type="text"
                  value={searchValue}
                  onChange={handleSearchValue}
                  placeholder={t('noah285')}
                />
                {searchValue && (
                  <div className={`${styles.clean} flexc pointer`} onClick={() => setSearchValue('')}>
                    ×
                  </div>
                )}
              </div>
            </div>
          )} */}
        </div>

        {/* 底部列表 */}
        <div className={styles.table}>
          {/* 表头 */}
          {windowSize.width > 1200 && (
            <div className={`${styles.header} flex flexb`}>
              <div className={styles.one}>{t('noah286')}</div>
              <div className={styles.two}>{t('noah361')}</div>
              <div className={`${styles.three} flex flexend`}>
                {t('noah324')}
                &nbsp;
                <QuestionHelper type="info" text={t('noah394')} placement="top-start" ml="0" />
              </div>
              <div className={`${styles.four} flex flexend`}>
                {t('noah325')}
                &nbsp;
                <QuestionHelper type="info" text={t('noah393')} placement="top-start" ml="0" />
              </div>
              <div className={styles.five}>{t('noah255')}</div>
              <div className={`${styles.six} flex flexc flexend`}>
                {t('noah366')}%&nbsp;
                <QuestionHelper type="info" text={t('noah364')} placement="top-start" ml="0" />
              </div>
            </div>
          )}
          {/* 内容 */}
          {windowSize.width > 1200 ? (
            <div className={styles.body}>
              {loading ? (
                <TableLoader />
              ) : list?.length > 0 ? (
                <div className={`${styles.list}`}>
                  {list.map((item, index) => (
                    <div className={`${styles.item} flexb`} key={index}>
                      <div className={`${styles.one} flex flexc flexstart`}>
                        {/* <ListLogo logoURI={item.img0} size="30px" />
                        <ListLogo logoURI={item.img1} size="30px" style={{ position: 'relative', left: '-6px' }} /> */}
                        {item.price_direction == 1 ? (
                          <DoubleCurrencyLogo token0={item.token1} token1={item.token0} size={30} />
                        ) : (
                          <DoubleCurrencyLogo token0={item.token0} token1={item.token1} size={30} />
                        )}
                        <div className={`flex flexc`} style={{ marginLeft: '30px' }}>
                          {item.price_direction == 1 ? (
                            <div className={`${styles.symbol0Name}`}>
                              {item.symbol1}
                              <span className={`${styles.symbol1Name}`}>/{item.symbol0}</span>
                            </div>
                          ) : (
                            <div className={`${styles.symbol0Name}`}>
                              {item.symbol0}
                              <span className={`${styles.symbol1Name}`}>/{item.symbol1}</span>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* 总票数/占比 */}
                      {Number(item.weight) >= 0.01 && (
                        <div className={`${styles.two} flex flexcol flexjc`}>
                          <div>{truncateZero(item.weight, 2)}</div>
                          <div className={styles.small}>{truncateZero(Number(item.proportion) * 100, 2)}%</div>
                        </div>
                      )}
                      {Number(item.weight) > 0 && Number(item.weight) < 0.01 && (
                        <div className={`${styles.two} flex flexcol flexjc`}>
                          <div>&lt; 0.01</div>
                          <div className={styles.small}>0.00%</div>
                        </div>
                      )}
                      {Number(item.weight) == 0 && (
                        <div className={`${styles.two} flex flexcol flexjc`}>
                          <div>0.00</div>
                          <div className={styles.small}>0.00%</div>
                        </div>
                      )}
                      {/* 手续费分成 */}
                      <div className={`${styles.three} flex flexcol flexjc`}>
                        {item.fee_sharing.length > 0 ? (
                          <div>
                            {item.fee_sharing.map((items, index_fee) => (
                              <div className={``} key={index_fee}>
                                {items?.quantity != 0 ? (
                                  <div>
                                    {truncateZero(items?.quantity, 4)} {items.symbol}
                                  </div>
                                ) : (
                                  <div>{index_fee == 0 && <div>-</div>}</div>
                                )}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div>-</div>
                        )}
                      </div>
                      {/* <div className={`${styles.three} flex flexcol flexjc`}>
                        {item.fee_sharing.map((items, index) => (
                          <div className={``}>
                            <div>{items.quantity} {items.symbol}</div>
                          </div>
                        ))}
                      </div> */}
                      {/* {Number(item.threeVal) > 0.01 && (
                        <div className={`${styles.two} flex flexcol flexjc`}>
                          <div>$ {item.threeVal}</div>
                        </div>
                      )}
                      {Number(item.threeVal) < 0.01 && Number(item.towVal) != 0 && (
                        <div className={`${styles.two} flex flexcol flexjc`}>
                          <div>$ &lt; 0.01</div>
                        </div>
                      )}
                      {Number(item.threeVal) == 0 && (
                        <div className={`${styles.two} flex flexcol flexjc`}>
                          <div>$ 0.00</div>
                        </div>
                      )} */}
                      {/* <div className={`${styles.three} flex flexcol flexjc`}>
                      <div>{item.threeVal}</div>
                      <div className={styles.small}>{item.threeUs}</div>
                    </div> */}
                      {/* 贿赂奖励 */}
                      <div className={`${styles.four} flex flexcol flexjc`}>
                        {item.bribeList.length > 0 ? (
                          <div>
                            {item.bribeList.map((items, index) => (
                              <div className={``}>
                                <div>
                                  {/* {truncateZero(items.quantity, 4)} {items.symbol} */}
                                  {formatEffectiveNumber(items?.quantity)} {items.symbol}
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div>-</div>
                        )}
                      </div>
                      {/* {Number(item.baseRate) > 0 && (
                        <div className={`${styles.four} flex flexcol flexjc`}>
                          <div>{item.baseRate} ABC</div>
                          <div>{item.heightRate} BCD</div>
                        </div>
                      )}
                      {Number(item.baseRate) <= 0 && (
                        <div className={`${styles.four} flex flexcol flexjc`}>
                          <div>-</div>
                        </div>
                      )} */}
                      {/* 总年化 */}
                      <div className={`${styles.five} flex flexend`}>
                        {/* <div>{item.total_yield ? truncateZero(item.total_yield * 100, 2) + '%' : '-'}</div> */}
                        {/* <div>{item.total_yield ? '$ ' + item.total_yield : '-'}</div> */}
                        {item.total_yield > 0.01 ? (
                          <span>$ {truncateZero(item.total_yield, 2)}</span>
                        ) : item.total_yield == 0 ? (
                          <span>$ 0.00</span>
                        ) : (
                          <span>$ &lt; 0.01</span>
                        )}
                      </div>
                      <div className={`${styles.six} flex flexend`}>
                        <span className={`${styles.sign} ${styles.sign_redu}`} onClick={() => handleVote(item, false)}>
                          {/* - */}
                          <img src="/images/all/redu.png" alt="" className={styles.reduImg} />
                        </span>
                        <div className={`${styles.inputBox}`}>
                          <input
                            disabled
                            className={styles.inputRate}
                            type="text"
                            value={votes[item.id] !== undefined && votes[item.id] ? votes[item.id] + '%' : ''}
                            onChange={handleSearchValue}
                            placeholder={t('0%')}
                          />
                        </div>
                        <span
                          className={`${styles.sign} ${styles.sign_add}`}
                          onClick={() => {
                            if (totalVotes == 100) return
                            handleVote(item, true)
                          }}
                          style={{
                            cursor: totalVotes >= 100 ? 'not-allowed' : 'pointer',
                            opacity: totalVotes >= 100 ? 0.5 : 1,
                          }}
                        >
                          {/* + */}
                          <img src="/images/all/ad.png" alt="" className={styles.adImg} />
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <Flex flexDirection="column" alignItems="center" justifyContent="center" height="500px">
                  <img src="/images/claim/nodata.png" width={100} alt="" />
                  <Text textAlign="center" maxWidth="400px" fontSize="16px" mt="16px" color="#85868A">
                    {t('noah116')}
                  </Text>
                </Flex>
              )}
            </div>
          ) : (
            <div className={styles.body}>
              <div className={`${styles.list}`}>
                <div className={`${styles.header} flex flexb`}>
                  <div className={styles.one}>{t('noah286')}</div>
                  <div className={styles.two}>{t('noah361')}</div>
                  <div className={styles.three}>{t('noah255')}</div>
                </div>
                {loading ? (
                  <TableLoader />
                ) : list?.length > 0 ? (
                  <div>
                    {list.map((item, index) => (
                      <div className={`${styles.item} flexb`} key={index}>
                        <div className={`${styles.data} flexb`}>
                          <div className={`${styles.one} flex flexc flexstart`}>
                            {/* <ListLogo logoURI={item.img0} size="30px" />
                          <ListLogo logoURI={item.img1} size="30px" style={{ position: 'relative', left: '-6px' }} /> */}
                            {item.price_direction == 1 ? (
                              <DoubleCurrencyLogo token0={item.token1} token1={item.token0} size={24} />
                            ) : (
                              <DoubleCurrencyLogo token0={item.token0} token1={item.token1} size={24} />
                            )}
                            <div className={`flex flexc`} style={{ marginLeft: '15px' }}>
                              {item.price_direction == 1 ? (
                                <div className={`${styles.symbol0Name}`}>
                                  {item.symbol1}
                                  <span className={`${styles.symbol1Name}`}>/{item.symbol0}</span>
                                </div>
                              ) : (
                                <div className={`${styles.symbol0Name}`}>
                                  {item.symbol0}
                                  <span className={`${styles.symbol1Name}`}>/{item.symbol1}</span>
                                </div>
                              )}
                            </div>
                          </div>

                          {/* 总票数/占比 */}
                          {Number(item.weight) >= 0.01 && (
                            <div className={`${styles.two} flex flexcol flexjc`}>
                              <div>{truncateZero(item.weight, 2)}</div>
                              <div className={styles.small}>{truncateZero(Number(item.proportion) * 100, 2)}%</div>
                            </div>
                          )}
                          {Number(item.weight) > 0 && Number(item.weight) < 0.01 && (
                            <div className={`${styles.two} flex flexcol flexjc`}>
                              <div>&lt; 0.01</div>
                              <div className={styles.small}>0.00%</div>
                            </div>
                          )}
                          {Number(item.weight) == 0 && (
                            <div className={`${styles.two} flex flexcol flexjc`}>
                              <div>0.00</div>
                              <div className={styles.small}>0.00%</div>
                            </div>
                          )}
                          {/* {Number(item.towVal) > 0.01 && (
                            <div className={`${styles.two} flex flexcol flexjc`}>
                              <div>{item.towVal}</div>
                              <div className={styles.small}>{item.twoRate}</div>
                            </div>
                          )}
                          {Number(item.towVal) < 0.01 && Number(item.towVal) != 0 && (
                            <div className={`${styles.two} flex flexcol flexjc`}>
                              <div>&lt; 0.01</div>
                              <div className={styles.small}>0.00%</div>
                            </div>
                          )}
                          {Number(item.towVal) == 0 && (
                            <div className={`${styles.two} flex flexcol flexjc`}>
                              <div>0.00</div>
                              <div className={styles.small}>0.00%</div>
                            </div>
                          )} */}
                          {/* 手续费分成 */}
                          {/* {Number(item.threeVal) > 0.01 && 
                        <div className={`${styles.two} flex flexcol flexjc`}>
                          <div>{item.threeVal}</div>
                          <div className={styles.small}>{item.threeUs}</div>
                        </div>
                      }
                      {(Number(item.threeVal) < 0.01 && Number(item.towVal) != 0) && 
                        <div className={`${styles.two} flex flexcol flexjc`}>
                          <div>$ &lt; 0.01</div>
                          <div className={styles.small}>$ &lt; 0.01</div>
                        </div>
                      }
                      {Number(item.threeVal) == 0 && 
                        <div className={`${styles.two} flex flexcol flexjc`}>
                          <div>$ 0.00</div>
                          <div className={styles.small}>$ 0.00</div>
                        </div>
                      } */}

                          {/* <div className={`${styles.three} flex flexcol flexjc`}>
                        <div>{item.threeVal}</div>
                        <div className={styles.small}>{item.threeUs}</div>
                      </div> */}

                          {/* {Number(item.baseRate) > 0 &&  
                        <div className={`${styles.four} flex flexcol flexjc`}>
                          <div>{item.baseRate} ABC</div>
                          <div>{item.heightRate} BCD</div>
                        </div>
                      }
                      {Number(item.baseRate) <= 0 &&  
                        <div className={`${styles.four} flex flexcol flexjc`}>
                          <div>-</div>
                        </div>
                      } */}
                          {/* {item.total_yield ? (
                            <div className={`${styles.three} flex flexend`}>
                              <div
                                className={`flexc pointer`}
                                onClick={() => {
                                  openModalWithItem(item)
                                }}
                              >
                                <span>{truncateZero(item.total_yield * 100, 2) + '%'}</span>
                                <img src="/images/all/menu.png" alt="" className={`${styles.lpImg}`} />
                              </div>
                            </div>
                          ) : (
                            <div className={`${styles.three} flex flexend`}>
                              <span>-</span>
                            </div>
                          )} */}
                          {item.total_yield > 0.01 ? (
                            <div className={`${styles.three} flex flexend`}>
                              <div
                                className={`flexc pointer`}
                                onClick={() => {
                                  openModalWithItem(item)
                                }}
                              >
                                <span>$ {truncateZero(item.total_yield, 2)}</span>
                                <img src="/images/all/menu.png" alt="" className={`${styles.lpImg}`} />
                              </div>
                            </div>
                          ) : item.total_yield == 0 ? (
                            <div className={`${styles.three} flex flexend`}>
                              <div className={`flexc pointer`}>
                                <span>$ 0.00</span>
                                {/* <img src="/images/all/menu.png" alt="" className={`${styles.lpImg}`} /> */}
                              </div>
                            </div>
                          ) : (
                            <div className={`${styles.three} flex flexend`}>
                              <div
                                className={`flexc pointer`}
                                onClick={() => {
                                  openModalWithItem(item)
                                }}
                              >
                                <span>$ &lt; 0.01</span>
                                <img src="/images/all/menu.png" alt="" className={`${styles.lpImg}`} />
                              </div>
                            </div>
                          )}
                        </div>

                        <div className={`${styles.go} flex flexb`}>
                          {/* 投票 */}
                          <div className={`${styles.label}`}>{t('noah366')}</div>
                          <div className={`${styles.six} flex flexend`}>
                            <span
                              className={`${styles.sign} ${styles.sign_redu}`}
                              onClick={() => handleVote(item, false)}
                            >
                              {/* - */}
                              <img src="/images/all/redu.png" alt="" className={styles.reduImg} />
                            </span>
                            <div className={`${styles.inputBox}`}>
                              <input
                                disabled
                                className={styles.inputRate}
                                type="text"
                                value={votes[item.id] !== undefined && votes[item.id] ? votes[item.id] + '%' : ''}
                                onChange={handleSearchValue}
                                placeholder={t('0%')}
                              />
                            </div>
                            <span
                              className={`${styles.sign} ${styles.sign_add}`}
                              onClick={() => {
                                if (totalVotes == 100) return
                                handleVote(item, true)
                              }}
                              style={{
                                cursor: totalVotes >= 100 ? 'not-allowed' : 'pointer',
                                opacity: totalVotes >= 100 ? 0.5 : 1,
                              }}
                            >
                              {/* + */}
                              <img src="/images/all/ad.png" alt="" className={styles.adImg} />
                            </span>
                            {/* <span className={`${styles.sign} ${styles.sign_redu}`}>-</span>
                          <div className={`${styles.inputBox}`}>
                            <input
                              disabled
                              className={styles.inputRate}
                              type="text"
                              value={searchValue}
                              onChange={handleSearchValue}
                              placeholder={t('0%')}
                            />
                          </div>
                          <span className={`${styles.sign} ${styles.sign_add}`}>+</span> */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <Flex flexDirection="column" alignItems="center" justifyContent="center" height="280px">
                    <img src="/images/claim/nodata.png" width={80} alt="" />
                    <Text textAlign="center" maxWidth="400px" fontSize="16px" mt="16px" color="#85868A">
                      {t('noah116')}
                    </Text>
                  </Flex>
                )}
              </div>
            </div>
          )}
          {/* <div className={`${styles.fullscreen_container}`}> */}

          <div className={`${styles.last} flex`}>
            {windowSize.width > 1200 && (
              <div className={`${styles.allScore}`}>
                {t('noah365')}: <span>{totalVotes ? totalVotes : '0.00'}%</span>
              </div>
            )}
            {/* 投票 */}
            {account ? (
              <div className={windowSize.width > 1200 ? `flex flexb` : ''}>
                {reset === 1 && (
                  <div
                    className={`${styles.reset_btn} flexc pointer`}
                    onClick={() => {
                      handleReset()
                    }}
                  >
                    {t('noah607')}
                  </div>
                )}

                <div style={{ width: windowSize.width > 1200 ? 'auto' : '100%' }}>
                  <div
                    className={`${
                      noVotes ||
                      loading ||
                      state.totalVotes != 100 ||
                      getRes(myVotes, 4) == 0 ||
                      reset === 0 ||
                      reset === 2
                        ? styles.disabled_btn
                        : styles.go_vote
                    } flexc pointer`}
                    style={{
                      cursor:
                        noVotes || state.totalVotes != 100 || getRes(myVotes, 4) == 0 || reset === 0 || reset === 2
                          ? 'not-allowed'
                          : 'pointer',
                    }}
                    onClick={() => {
                      if (
                        state.totalVotes != 100 ||
                        noVotes ||
                        !account ||
                        getRes(myVotes, 4) == 0 ||
                        reset === 0 ||
                        reset === 2
                      )
                        return
                      onPresentVoteModal()
                    }}
                  >
                    {/*  ? 本纪元已投票 : 投票 */}
                    {/* reset===0 本记元已投票，无取消投票*/}
                    {/* reset===1 本记元可投票，可取消投票*/}
                    {/* reset===2 本记元已取消投票，无取消投票*/}
                    {/* reset===3 本记元可投票，无取消投票*/}

                    {reset === 0 ? (
                      <span>{t('noah436')}</span>
                    ) : reset === 2 ? (
                      // 本记元已取消投票
                      <span>{t('noah609')}</span>
                    ) : (
                      (reset === 1 || reset === 3) && (
                        <span>
                          {state.totalVotes == 100 || state.totalVotes == 0 ? (
                            <span>{t('noah366')}</span>
                          ) : (
                            <span>{t('%num% voting rights unallocated', { num: 100 - state.totalVotes + '%' })}</span>
                          )}
                        </span>
                        // state.totalVotes == 100 || state.totalVotes == 0) ? (
                        //   <span>{t('noah366')}</span>
                        // ) : (
                        //   <span>{t('%num% voting rights unallocated', { num: 100 - state.totalVotes + '%' })}</span>
                        // )
                        // <span>aaa</span>
                      )
                    )}
                  </div>
                </div>
              </div>
            ) : (
              // 连接钱包
              <div className={`${styles.go_vote} flexc pointer`} onClick={handleClick}>
                <span>{t('noah366')}</span>
              </div>
            )}
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  )
}
